var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.237,
    height: 15.213,
    viewBox: "0 0 18.237 15.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -40.484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7,40.484H1.539A1.541,1.541,0,0,0,0,42.023V54.158A1.541,1.541,0,0,0,1.539,55.7H16.7a1.541,1.541,0,0,0,1.539-1.539V42.023A1.541,1.541,0,0,0,16.7,40.484Zm-15.16,1.3H16.7a.236.236,0,0,1,.235.235v3.134H1.3V42.023A.236.236,0,0,1,1.539,41.788Zm15.16,12.6H1.539a.236.236,0,0,1-.235-.235v-7.7h15.63v7.7A.236.236,0,0,1,16.7,54.393Z",
    transform: "translate(0 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.662,97.548a.867.867,0,1,0-.866-.867A.868.868,0,0,0,63.662,97.548Z",
    transform: "translate(-60.45 -53.263)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.762,97.548a.867.867,0,1,0-.868-.867A.867.867,0,0,0,125.762,97.548Z",
    transform: "translate(-120.228 -53.263)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.89,97.548a.867.867,0,1,0-.866-.867A.868.868,0,0,0,187.89,97.548Z",
    transform: "translate(-180.037 -53.263)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.e26e5d885e32e761b5a07cef21949324.svg";
export { ForwardRef as ReactComponent };